export default "__VITE_ASSET__DNs56Pm6__"